import React from "react";
import Listing from "./Listing";

export const Hostdashboard = () => {
  //states

  




  return (
    <>
      <div className="h-100vh">
      <Listing />
      </div>
    </>
  );
};

export default Hostdashboard;
